import React from "react";
import ReactSelect from "react-select";
import ReactTable from "@dhn/components/molecules/data-table";
import MedicalResultsModal from "../../../../../../components/medical-results/MedicalResultsModal";
import MedicalFilesViewerModal from "../../../../../../components/medical-results/MedicalFilesViewerModal";
import { Button, Col, Label, Row, TabPane } from "reactstrap";
import useLaboratoryExamsActions from "./useLaboratoryExamsActions";

export default function LaboratoryExams({
  subTabExamsLaboratory,
  onChange,
  appointmentId,
  appointmentDate,
  patientId,
  isPageModalHistory,
  otherResultRecords,
}) {
  const [state, actions] = useLaboratoryExamsActions({
    subTabExamsLaboratory,
    onChange,
    appointmentId,
    appointmentDate,
    patientId,
    isPageModalHistory,
    otherResultRecords,
  });

  const {
    selectedExam,
    availableExamOptions,
    canManageResults,
    examRecords,
    resultRecords,
    columnsExam,
    columnsResults,
    isResultsModalOpen,
    resultDate,
    resultLabel,
    files,
    editingRecord,
    errorMessage,
    viewerState,
    getRootProps,
    getInputProps,
    appointmentUsedBytes,
    isDiscardConfirmationOpen,
  } = state;

  return (
    <TabPane tabId={2}>
      <Row form>
        {!isPageModalHistory && (
          <Col md="4">
            <Label>Examen:</Label>
            <ReactSelect
              options={availableExamOptions || []}
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.id}
              value={selectedExam}
              placeholder="Seleccionar Examen"
              onChange={actions.handleAddExam}
            />
          </Col>
        )}

        <Col className="d-flex align-items-end justify-content-end mb-1">
          <Button
            type="button"
            color="primary"
            className="btn-color-primary"
            onClick={actions.handleOpenResultsModal}
          >
            <i className="fa fa-upload" />
            {canManageResults
              ? " Agregar Resultados de Laboratorio"
              : " Ver Resultados de Laboratorio"}
          </Button>
        </Col>
      </Row>

      <Row form className="mt-2">
        <Col>
          <ReactTable
            data={examRecords}
            defaultPageSize={5}
            noDataText="No hay Estudios de Laboratorio"
            className="-striped -highlight"
            columns={columnsExam}
          />
        </Col>
      </Row>

      <MedicalResultsModal
        isOpen={isResultsModalOpen}
        toggle={actions.toggleResultsModal}
        title="Resultados de Laboratorio"
        canManageResults={canManageResults}
        resultDate={resultDate}
        onChangeResultDate={actions.handleChangeResultDate}
        resultLabel={resultLabel}
        onChangeResultLabel={actions.handleChangeResultLabel}
        labelPlaceholder="Ej. Hemograma completo"
        getRootProps={getRootProps}
        getInputProps={getInputProps}
        files={files}
        appointmentUsedBytes={appointmentUsedBytes}
        onRemoveLocalFile={actions.handleRemoveLocalFile}
        onAddResult={actions.handleAddResult}
        addButtonLabel={editingRecord ? "Guardar Cambios" : ""}
        errorMessage={errorMessage}
        resultRecords={resultRecords}
        columnsResults={columnsResults}
        emptyText="No hay resultados de laboratorio"
        isDiscardConfirmationOpen={isDiscardConfirmationOpen}
        onContinueEditing={actions.handleContinueEditing}
        onDiscardAndClose={actions.handleDiscardAndClose}
      />

      <MedicalFilesViewerModal
        isOpen={viewerState.isOpen}
        toggle={actions.closeViewer}
        title={viewerState.title}
        files={viewerState.files}
        currentIndex={viewerState.index}
        onPrev={actions.handlePreviousFile}
        onNext={actions.handleNextFile}
        isLoading={viewerState.loading}
        errorMessage={viewerState.error}
        onDeleteCurrent={actions.handleDeleteCurrent}
        canDelete={canManageResults}
      />
    </TabPane>
  );
}
